import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclamation-mark-blue",
  "use": "exclamation-mark-blue-usage",
  "viewBox": "77 0 100 256",
  "content": "<symbol viewBox=\"77 0 100 256\" xmlns=\"http://www.w3.org/2000/svg\" id=\"exclamation-mark-blue\"><g fill=\"#003595\" stroke-miterlimit=\"10\" stroke-width=\"0\" transform=\"matrix(2.81 0 0 2.81 1.407 1.407)\"><path d=\"m45 66.364a5.565 5.565 0 0 1 -5.56-5.321l-5.132-49.519c-.467-6.22 4.454-11.524 10.692-11.524s11.159 5.304 10.692 11.524l-5.132 49.519a5.565 5.565 0 0 1 -5.56 5.321z\" /><circle cx=\"44.998\" cy=\"81.128\" r=\"8.868\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol